module.exports = __webpack_public_path__ + "mobile/img/img_service.147a99b6.png";